'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.processSideEffects = processSideEffects;
exports.default = createStore;

var _ramda = require('ramda');

var _redux = require('redux');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _reaction = require('../reaction');

var _model = require('../model');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var storeDebug = (0, _debug2.default)('modula:store');

function processSideEffects(effects) {
  storeDebug('process side effects', effects);

  var _effects = _toArray(effects),
      newModel = _effects[0],
      sideEffectFunctions = _effects.slice(1);

  (0, _ramda.forEach)(function (sideEffect) {
    setTimeout(function () {
      sideEffect();
    }, 0);
  }, sideEffectFunctions);

  return newModel;
}

var createRootModel = function createRootModel(DecoratedModel, getDispatch) {
  var ActionTypes = {
    INIT: 'ROOT_INIT',
    DESTROY: 'ROOT_DESTROY'
  };

  var RootModel = function (_Model) {
    _inherits(RootModel, _Model);

    function RootModel() {
      _classCallCheck(this, RootModel);

      return _possibleConstructorReturn(this, (RootModel.__proto__ || Object.getPrototypeOf(RootModel)).apply(this, arguments));
    }

    _createClass(RootModel, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return { dispatch: getDispatch() };
      }
    }, {
      key: 'sendInit',
      value: function sendInit() {
        storeDebug('root model send init');

        getDispatch()({ type: ActionTypes.INIT, path: [] });
      }
    }, {
      key: 'recvInit',
      value: function recvInit() {
        return {
          type: ActionTypes.INIT,
          update: function update(model) {
            var newModel = model.set('decoratedModel', new DecoratedModel());

            return [newModel];
          }
        };
      }
    }, {
      key: 'sendDestroy',
      value: function sendDestroy() {
        storeDebug('root model send destroy');

        getDispatch()({ type: ActionTypes.DESTROY, path: [] });
      }
    }, {
      key: 'recvDestroy',
      value: function recvDestroy() {
        return {
          type: ActionTypes.DESTROY,
          update: function update(model) {
            return [model.set('decoratedModel', null)];
          }
        };
      }
    }]);

    return RootModel;
  }(_model.Model);

  RootModel.actionTypes = ActionTypes;

  RootModel.defaultProps = {
    decoratedModel: null
  };

  RootModel.childContextTypes = {
    dispatch: '\n      Dispatch action for store to handle.\n      First argument is the action object.\n      Returns null.\n    '
  };

  return new RootModel();
};

var createRootReducer = function createRootReducer(DecoratedModel, getDispatch) {
  return function rootReducer() {
    var rootModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments[1];

    storeDebug('root reducer called with model', rootModel, 'action', action);

    if (action.type === '@@INIT' || action.type === '@@redux/INIT') {
      return createRootModel(DecoratedModel, getDispatch);
    } else {
      return processSideEffects((0, _reaction.reactionReducer)(rootModel, action));
    }
  };
};

function createStore(DecoratedModel, enhancer) {
  var store = (0, _redux.createStore)(createRootReducer(DecoratedModel, function () {
    return store.dispatch;
  }), enhancer);

  return store;
}